// Added parts of es6 which are necessary for your project or your browser support requirements.
import 'core-js/es6/array'
import 'core-js/es6/object'
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import 'core-js/es7/object'
import 'core-js/es7/reflect'
import 'raf/polyfill'



// WEBPACK FOOTER //
// ./src/polyfills.ts